import { useEffect, useRef, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { playReadyChime } from "@/lib/sound";

// Polls the client's orders. Faster cadence while a file is being analyzed.
// Plays a chime + toast when any order transitions to "completed".
export function useOrdersPolling() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const prevStatus = useRef({});
  const seeded = useRef(false);

  const tick = useCallback(async () => {
    try {
      const { data } = await api.get("/orders");
      if (seeded.current) {
        data.forEach((o) => {
          const was = prevStatus.current[o.id];
          if (was && was !== "completed" && o.status === "completed") {
            playReadyChime();
            toast.success(`Fichier prêt : ${o.vehicle_brand} ${o.vehicle_model}`, {
              description: "Votre fichier traité est disponible au téléchargement.",
            });
          }
        });
      }
      prevStatus.current = Object.fromEntries(data.map((o) => [o.id, o.status]));
      seeded.current = true;
      setOrders(data);
      return data.some((o) => o.analyzing);
    } catch (e) {
      return false;
    }
  }, []);

  useEffect(() => {
    let timer;
    let cancelled = false;
    const loop = async () => {
      const anyAnalyzing = await tick();
      if (cancelled) return;
      setLoading(false);
      timer = setTimeout(loop, anyAnalyzing ? 3000 : 8000);
    };
    loop();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [tick]);

  return { orders, loading };
}
